import { Injectable } from '@angular/core'
import { SidebarQuery, SidebarQueryService } from '@app-graphql/schema'
import { Observable } from 'rxjs'
import { Apollo } from 'apollo-angular'
@Injectable({ providedIn: 'root' })
export class SidebarService {

    constructor(
        private sidebarQueryService: SidebarQueryService,
    ) {
    }

    public getSidebar(locale: string): Observable<Apollo.QueryResult<SidebarQuery>> {
        return this.sidebarQueryService.fetch({ variables: { locale } })
    }
}
